import { useContext, useEffect, useState } from "react";
import { getInlineLoader } from "../Helpers";
import { AppContext } from "../App";
import {
  IoCashOutline,
  IoCarSportOutline,
  IoCubeOutline,
  IoMedkitOutline,
  IoHardwareChipOutline,
} from "react-icons/io5";

import banner1 from "../assets/banner1.jpg";
import banner2 from "../assets/banner2.jpg";
import banner3 from "../assets/banner3.jpg";
import banner4 from "../assets/banner4.jpg";
import { IoMdArrowDropright } from "react-icons/io";

export default function HomeBanner1() {
  const [ready, setReady] = useState(false);
  const [bgIndex, setBgIndex] = useState(0);

  
  const appContext = useContext(AppContext);

  const banners = [banner1, banner2, banner3, banner4];

  useEffect(() => {
    setReady(true);
  }, []);

  useEffect(() => {
    if (!ready) return;

    const interval = setInterval(() => {
      setBgIndex((prev) => (prev + 1) % banners.length);
    }, 3500);

    return () => clearInterval(interval);
  }, [ready, banners.length]);

  if (!ready) {
    return (
      <div className="container mSupportLoading">
        {getInlineLoader()}
      </div>
    );
  }

  const scopeItems = [
    { icon: <IoCashOutline size={26} />, label: "Finance" },
    { icon: <IoCarSportOutline size={26} />, label: "Mobility" },
    { icon: <IoCubeOutline size={26} />, label: "Logistics" },
    { icon: <IoMedkitOutline size={26} />, label: "Pharmaceuticals" },
    { icon: <IoHardwareChipOutline size={26} />, label: "Technology" },
  ];

  return (
    <section className="MainBodySection">
      <div
        style={{
          height: "calc(100vh - var(--topBarHeight))",
          position: "relative",
        }}
      >
        {/* Background slideshow */}
        {banners.map((banner, i) => (
          <div
            key={i}
            style={{
              backgroundImage: `url(${banner})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              position: "absolute",
              height: "100%",
              inset: 0,
              transition: "opacity 1.8s ease",
              opacity: i === bgIndex ? 1 : 0,
            }}
          />
        ))}

        {/* Overlay */}
        <div
          style={{
            position: "relative",
            width: "100%",
            height: "100%",
            background:
              "linear-gradient(180deg, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.6) 100%)",
          }}
        >
          <div className="container h-100">
            <div className="row align-items-center h-100">
              <div className="col-lg-10 mx-auto text-center px-4">

                {/* Company Name */}
                <h1
                  className="text-primary font-semi-bold mb-3"
                  style={{
                    textTransform: "uppercase",
                    letterSpacing: "1px",
                    fontSize: "clamp(26px, 4.5vw, 48px)",
                  }}
                >
                  NDOMANO GROUP OF COMPANIES
                </h1>

                {/* Positioning Line */}
                <p
                  className="text-light mb-5"
                  style={{
                    textTransform: "uppercase",
                    letterSpacing: "0.8px",
                    fontSize: "14px",
                    opacity: 0.85,
                  }}
                >
                  Tech-First. Future-Focused. Africa-Built.
                </p>

                {/* Scope Cards */}
                <div className="row justify-content-center">
                  {scopeItems.map((item, idx) => (
                    <div key={idx} className="col-6 col-md-4 col-lg-2 mb-4">
                      <div
                        style={{
                          height: "100%",
                          padding: "18px 14px",
                          borderRadius: "16px",
                          background: "rgba(255,255,255,0.12)",
                          backdropFilter: "blur(14px)",
                          WebkitBackdropFilter: "blur(14px)",
                          border: "1px solid rgba(255,255,255,0.2)",
                          transition: "all 0.35s ease",
                        }}
                        className="text-center"
                      >
                        <div
                          className="text-light mb-2"
                          style={{ opacity: 0.95 }}
                        >
                          {item.icon}
                        </div>

                        <div
                          className="text-light"
                          style={{
                            fontSize: "13.5px",
                            letterSpacing: "0.4px",
                            opacity: 0.9,
                          }}
                        >
                          {item.label}
                        </div>
                      </div>
                    </div>
                  ))}

                  <div className="col-md-12 text-center mt-5">
                    <button
                      className="px-5 py-3 rounded-pill border-0 font-bold d-flex align-items-center justify-content-center gap-2 mt-3 mx-auto"
                      style={{
                        background: "linear-gradient(90deg, #00356d, #0055a4)",
                        color: "#fff",
                        fontSize: "1.05rem",
                        boxShadow: "0 8px 20px rgba(0, 53, 109, 0.4)",
                        transition: "all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
                      }}
                      onClick={() => appContext.navTo({ item: "about_us" })}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "translateY(-4px) scale(1.03)";
                        e.currentTarget.style.boxShadow = "0 12px 30px rgba(0, 53, 109, 0.6)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "translateY(0) scale(1)";
                        e.currentTarget.style.boxShadow = "0 8px 20px rgba(0, 53, 109, 0.4)";
                      }}
                    >
                      Discover Our Vision
                      <IoMdArrowDropright size={24} />
                    </button>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
